'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteShade', ['$rootScope', function ($rootScope) {
      return {
        template: '<div class="sa-note-shade"></div>',
        restrict: 'A',
        scope: {
          me: '=',
          org: '='
        },
        link: function(scope, elem) {
          scope.state = {
            overlayOpen: false,
            q: {
              overlayOpen: function() { return scope.state.overlayOpen; }
            }
          };

          $(elem).on('click touchstart', function () {
            if (scope.state.overlayOpen) {
              $rootScope.$broadcast('note-overlay-close');
            } else {
              // do nothing
            }
          });

          scope.$on('note-overlay-open', function() {
            scope.state.overlayOpen = true;

            $('.sa-note-shade').addClass('active');
          });

          scope.$on('note-overlay-close', function() {
            scope.state.overlayOpen = false;

            $('.sa-note-shade').removeClass('active');
          });
        }
      };
    }]);
